import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import CardItem from './CardItem';

function DialogItemsList({ open, onClose, listItems }) {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle>
      <DialogContent>{listItems}</DialogContent>
    </Dialog>
  );
}

export default DialogItemsList;
